import { render } from "./NewsMaster.vue?vue&type=template&id=b5a36f70&scoped=true"
import script from "./NewsMaster.vue?vue&type=script&lang=js"
export * from "./NewsMaster.vue?vue&type=script&lang=js"

import "./NewsMaster.vue?vue&type=style&index=0&id=b5a36f70&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5a36f70"]])

export default __exports__